import { BatteryClockOutlineIcon } from './BatteryClockOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 5756A4F3-FBED-4F81-8B97-AF391EC4D893
 * name battery-clock-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-clock-outline.svg
 * tags
 * - Battery 
 * - Home Automation 
 * - Date / Time 
 */
export const BatteryEmptyClockIcon = BatteryClockOutlineIcon;
export default BatteryEmptyClockIcon